import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store, select } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { FileUploadDialogComponent } from '@platform/components/file-upload-widget/file-upload/file-upload-dialog/file-upload-dialog.component';
import { DialogV2Service } from '@platform/dialog/dialog-v2.service';
import { selectPortalConfig } from '@platform/platform.selectors';
import { PortalConfig } from '@platform/platform.state';
import { RootState } from '@root/app.state';
import { filter } from 'rxjs';

@Component({
  selector: 'app-widget-file-upload',
  templateUrl: './widget-file-upload.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WidgetFileUploadComponent implements OnInit {
  @Input() label = 'action';
  @Input() tooltip?: string;
  @Output() filesUploaded = new EventEmitter<FileList>();
  private config!: PortalConfig;

  constructor(
    private dialogService: DialogV2Service,
    private translateService: TranslateService,
    private store$: Store<RootState>,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.store$
      .pipe(
        select(selectPortalConfig),
        filter((config) => !!config),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((x) => (this.config = x!));
  }

  public openDialog(): void {
    this.dialogService
      .open(FileUploadDialogComponent, {
        data: {
          allowedFileFormats: this.config.allowedFileUploadFormatsDocuments,
          invalidCharacters: this.config.invalidFileAndFolderNameCharacters,
        },
      })
      .afterClosed()
      .pipe(filter((data) => !!data))
      .subscribe((data) => this.filesUploaded.emit(data?.files));
  }

  public getTranslatedLabel() {
    return this.translateService.instant(`file-upload.${this.label}`);
  }
}
